import React from "react"
import PropTypes from "prop-types"
import validateInput from "../../../view/shared/validations/validateAmount"
import { WarningMessage } from "../../../view/shared/notifications/Notifications"

import { Form, Container, Input, FormGroup } from "reactstrap"
import { connect } from "react-redux"
import stellarProcessing from "../../../view/assets/stellar-animation.gif"
import { toast } from "react-toastify"
import LastTransaction from "../../reverseTransactions/LastTrasaction"
import { currentTransactionContext } from "../../../store/actions/transactionContext"
import { initiateTransaction } from "../../../store/reducers/transactions/actions"

import { selectCreatedVslaInfo } from "../../../store/reducers/getVslas"
import { setCurrentPage } from "../../../store/reducers/navigation"
import { t } from "@lingui/macro"
import styles from "./style.module.css"
import { Trans, useLingui } from "@lingui/react"

const notify = (msg) => toast(msg)

const PayFine = (props) => {
  const { i18n } = useLingui()
  const [state, setState] = React.useState({
    amount: "",
    errors: {},
    loading: false,
  })

  React.useEffect(() => {
    props.pushTransactionContext("Fine paid")
  }, [])

  const onChange = (e) => setState({ ...state, [e.target.name]: e.target.value })

  const isValid = () => {
    const { errors, isValid } = validateInput(state)

    if (!isValid) {
      setState({ errors })
    }
    return isValid
  }

  const onSubmit = (e) => {
    e.preventDefault()
    if (isValid()) {
      processTransaction(state.amount)
      setState({ ...state, amount: "" })
    }
  }

  const processTransaction = (amount) => {
    const lang_code = i18n.locale

    const lang = {
      fr: {
        message: `Confirmer la cotisation de ${state.amount} pour le membre`,
      },
      en: {
        message: `Confirm contribution of ${state.amount} for member`,
      },
      sw: {
        message: `Thibitisha mwanachama ametoa mchango wa shilingi ${state.amount}`,
      },
      ZARMA: {
        message: `Zarma for Confirm contribution of ${state.amount} for member`,
      },
      HAOUSSA: {
        message: `Tabbatar da taimakon dala ${state.amount} daga ỳar rukuni`,
      },
      es: {
        message: `Confirmar contribución de ${state.amount} lempiras para miembro`,
      },
      lb: {
        message: `Confirm contribution of ${state.amount} for household`,
      },
      pt: {
        message: `Confirme a contribuição de ${state.amount} para o membro`,
      },
      ar: {
        message: `للأسرة ${state.amount} أكد مساهمة`,
      },
    }

    if (window.confirm(lang[lang_code].message)) {
      setState({ loading: true })
      const uuid = props.currentMember.pubkey
      props.commitTransaction({
        uid: uuid,
        type: "FINE_PAYMENT",
        amount: parseFloat(amount),
        ...(props.currentMember?.id
          ? {
            member_id: props.currentMember?.id,
          }
          : {
            memberCacheId:
              props.currentMember?.cacheId || props.currentMember?.pubkey,
          }),
      })

      notify(<WarningMessage msg={"Processing Transaction"} />)
      redirectBack()
    } else {
      notify(<WarningMessage />)
    }
  }
  const redirectBack = () => {
    props.setPage("group-memberActions")
  }

  if (!state.loading) {
    return (
      <div>
        <div>
          <h4 className={styles.header}>{props.currentMember?.full_name}</h4>
        </div>
        <div>
          <h4 className={styles.header}>
            <Trans id="Pay Fine">Pay Fine</Trans>
          </h4>
        </div>

        <Form onSubmit={onSubmit}>
          <Container>
            <FormGroup>
              <span className={styles.errorMessage}>{state.errors.amount}</span>
              <Input
                type="number"
                name="amount"
                placeholder={t({ id: "Fine Amount" })}
                value={state.amount}
                onChange={onChange}
                className={styles.formInput}
              />
            </FormGroup>

            <FormGroup>
              <Input
                type="submit"
                value={t({ id: "Pay Fine" })}
                name="submit"
                className={`btn btn-primary ${styles.submitButton}`}
              />
            </FormGroup>
          </Container>
        </Form>
        {props.isConnected && (
          <LastTransaction
            redirectBack={redirectBack}
            reversal_details={{
              sourceFundType: "fine",
              destFundType: "issuer",
              reversalTransactionType: "Fine reversed",
            }}
            transactions={props.transactions}
          />
        )}
      </div>
    )
  }

  if (state.loading) {
    return (
      <div className={styles.spinnerContainer}>
        <img src={stellarProcessing} className={styles.spinner} alt="Stellar" />
      </div>
    )
  }
}

PayFine.propTypes = {
  vsla: PropTypes.object,
  pushTransactionContext: PropTypes.func,
  currentMember: PropTypes.object,
  commitTransaction: PropTypes.func,
  ongoingMeeting: PropTypes.array,
  group: PropTypes.object,
  setPage: PropTypes.func,
  isConnected: PropTypes.bool,
  transactions: PropTypes.array,
}

const mapStateToProps = (state) => {
  const { accountV2, loadedMember } = state
  const selectMemberReversableTransactions = (type) => {
    const memberPubkey = loadedMember?.pubkey
    if (!memberPubkey) {
      return []
    }
    else if (!accountV2.online?.transactions) {
      return []
    }
    return accountV2.online?.transactions?.[memberPubkey]?.filter(tx => tx.type === type) || []
  }
  return {
    isConnected: state.isConnected,
    ongoingMeeting: state.meeting?.ongoing,
    currentMember: state.loadedMember,
    transactions: selectMemberReversableTransactions('FINE_PAYMENT'),
    vsla: state.vsla,
    group: state.group,
    vslaSummary: selectCreatedVslaInfo(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setPage: (page) => dispatch(setCurrentPage(page)),
    commitTransaction: (data) => dispatch(initiateTransaction(data)),
    pushTransactionContext: (type) => dispatch(currentTransactionContext(type)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PayFine)
